<template>
  <modal name="confirmAddVideo"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :width="520"
    :height="220"
  >
    <div class="cantainer">
      <div class="content">
        <span>
            <!-- 一个页面仅能添加一个视频。<br/>
            若您需要继续添加该视频素材/背景，那么会删除已添加的视频素材/背景。 -->
            一个页面仅能添加一个视频素材或数字人。<br/>
            若您需要继续添加素材，将会删除已添加的视频素材/数字人。
        </span>
      </div>
      <div class="footer">
        <div class="button button--primary" @click="cancel">取消</div>
        <div class="button button--primary" @click="confirm">继续添加</div>
      </div>
      <div class="close-btn" @click="clickToClose()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
/**
 * 限制视频数量的弹窗
 */
import toAnalysisParams from '@/plugins/toAnalysisParams'

export default {
  data () {
    return {
      selectedRecord: null,
      action: 'add'
    }
  },
  created () {

  },
  methods: {
    clickToClose () {
      this.$modal.hide('confirmAddVideo');
    },
    beforeOpen ({params} = {}) {
      if (params && params.action) {
        this.action = params.action;
      }
    },
    confirm () {
      this.$bus.emit('confirmAddVideo.goOn', this.action);
      this.$modal.hide('confirmAddVideo');
      this.$analysis(toAnalysisParams('popupWindow,click_insert_video,视频限制弹窗_继续添加'))
    },
    cancel () {
      this.$bus.emit('confirmAddVideo.cancel');
      this.$modal.hide('confirmAddVideo');
      this.$analysis(toAnalysisParams('popupWindow，click_cancel_video,视频限制弹窗_取消添加'))
    }
  }
}
</script>

<style lang="scss" scoped>
.cantainer {
  position: relative;
  width: 520px;
  height: 220px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 36px;
  margin-left: 24px;
  margin-right: 24px;
  line-height: 1.8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  >div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/confirmAddVideo.vue